<template>
  <div class="list">
    <div class="items">
      <container>
        <row justify-content="center">
          <column :size="24">
            <slot></slot>
          </column>
        </row>
      </container>
    </div>
  </div>
</template>

<script>
import {Container, Row, Column} from './layout'

export default {
  name: 'ListLayout',
  components: {
    Container, Row, Column
  }
}
</script>

<style lang="scss" scoped>
.list {
  min-height: inherit;
  display: flex;
  flex-direction: column;

  .items {
    display: flex;
    flex: 1;
    // align-items: center;

    ul {
      margin: 0px;
      padding: 0px;
      list-style: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// List.vue?a8008ee4